import { FormEvent, useState } from 'react';
import { Box, Button, Menu, TextField, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';
import { useIntl } from 'react-intl';

interface TableHeaderProps {
  title: string;
  onAdd?: (params: { id: string }) => any;
  children?: JSX.Element;
  shouldSkipOnAddId?: boolean;
}

export function TableHeader({ title, onAdd, children, shouldSkipOnAddId }: TableHeaderProps) {
  const intl = useIntl();
  const [anchorEl, setAnchorEl] = useState(null);
  const [newItemId, setNewItemId] = useState('');

  const handleMenu = (event: any) => {
    if (shouldSkipOnAddId) {
      onAdd?.({ id: 'undefined' });
      return;
    }
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onNewItemSubmit = (e: FormEvent) => {
    e.preventDefault();
    onAdd?.({ id: newItemId });
    handleClose();
    setNewItemId('');
  }

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'row', marginBottom: '13px', alignItems: 'center' }}>
        <Typography variant="h6" component="h2" color="primary" sx={{ flex: 1 }}>
          {title}
        </Typography>
        {children}
        {onAdd && (
          <Button
            variant="outlined"
            startIcon={<Add />}
            onClick={handleMenu}
          >
            {intl.formatMessage({ id: 'app.button.new.title' })}
          </Button>
        )}
      </Box>

      <Menu
        id="menu-new-item"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <form onSubmit={onNewItemSubmit} >
          <TextField
            label="ID"
            value={newItemId}
            focused required
            onChange={(event) => setNewItemId(event.target.value)}
          />
          <Button
            size="large"
            startIcon={<Add />}
            type="submit"
          >
            {intl.formatMessage({ id: 'app.button.create.title' })}
          </Button>
        </form>
      </Menu>
    </>
  )
}